import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MyEInvoiceSingleGeneralPoolDocHdrContainerModel } from '../../../../../models/aggregates/e-invoice/MyEInvoiceSingleGeneralPoolDocHdrContainerModel.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa } from '../../../..';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MyEInvoiceSingleGeneralPoolDocHdrService extends BaseApiPublicLoginTemplateService<MyEInvoiceSingleGeneralPoolDocHdrContainerModel, MyEInvoiceSingleGeneralPoolDocHdrContainerModel, MyEInvoiceSingleGeneralPoolDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/backoffice-ep'
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/'+ BaseApiTemplateService.LOGIN_ENTITY_EP
    this.endpoint_path_website_ep_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/'+ BaseApiTemplateService.WEBSITE_EP
    this.httpClient = http;
  }

  saveAndResubmit(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/save-and-resubmit/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  skipEinvoice(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/skip-e-invoice/backoffice-ep';
    if (visa.api_domain_url) {
      customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/single-general-pool-doc-hdrs/skip-e-invoice/backoffice-ep';
    }

    return this.httpClient.delete<ApiResponseModel<any>>(
      customUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

}
